var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 671,
    height: 642,
    viewBox: "0 0 671 642",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67,
    filter: "url(#filter0_f_1559_2519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.611 254.514C288.567 73.7166 -286.847 166.898 -310.492 175.619C-449.83 374.397 200.265 358.922 399.731 383.188C599.196 407.454 738.073 732.606 821.081 844.846C887.487 934.638 925.925 854.99 936.844 803.941C898.114 681.065 767.447 399.151 554.611 254.514Z",
    fill: "white",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.611 254.514C288.567 73.7166 -286.847 166.898 -310.492 175.619C-449.83 374.397 200.265 358.922 399.731 383.188C599.196 407.454 738.073 732.606 821.081 844.846C887.487 934.638 925.925 854.99 936.844 803.941C898.114 681.065 767.447 399.151 554.611 254.514Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1559_2519",
    x: -473.795,
    y: -0.0000915527,
    width: 1554.56,
    height: 1029.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 71.7,
    result: "effect1_foregroundBlur_1559_2519"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.50804a6f0b7b9045dedccb7e6a67696c.svg";
export { ForwardRef as ReactComponent };